<template>
  <v-container id="tarjetas-forms" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-credit-card" inline class="px-5 py-3" title="Tarjetas">
      <template v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="dialog = true">
          <v-icon large color="#ac8a2e">
            mdi-credit-card-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="search" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <validation-observer v-slot="{ handleSubmit }">
                <form id="altaTarjetas" @submit.prevent="handleSubmit(validateForm)">
                  <v-row align="center" justify="center">
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" name="numero tarjeta" rules="max:20">
                        <v-text-field v-model="dataForm.numero" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Numero tarjeta" :readonly="showdialog === 'show'" />
                      </validation-provider>
                    </v-col>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" name="banco" rules="required">
                        <v-select v-model="dataForm.banco_id" color="gold" :error-messages="errors" label="Banco" item-value="id" item-text="descripcion" :items="bancos" :readonly="showdialog === 'show'">
                          <template v-slot:item="{ attrs, item, on }">
                            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="v-sheet" elevation="0" v-on="on">
                              <v-list-item-content>
                                <v-list-item-title v-text="item.descripcion" />
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </form>
              </validation-observer>
              <v-card-actions>
                <v-spacer />
                <v-btn v-if="showdialog === 'edit'" color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn v-if="showdialog === 'edit'" color="blue darken-1" text form="altaTarjetas" type="submit" @click="dialog = false">
                  Guardar
                </v-btn>
                <v-btn v-if="showdialog === 'show'" color="blue darken-1" text @click="dialog= !dialog">
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-data-table
        :headers="headers"
        :items="tarjetas"
        :search.sync="search"
        :sort-by="['name', 'office']"
        :sort-desc="[false, true]"
        multi-sort
        @click:row="showItem"
      >
        <template v-if="$can('M_parametros')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        dialog: false,
        dialogItem: false,
        search: undefined,
        showdialog: 'show',
        headers: [
          { text: 'Numero tarjeta', sortable: false, value: 'numero' },
          { text: 'Pertenece al banco', sortable: false, value: 'banco.descripcion' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        tarjetas: [],
        bancos: [],
        editedIndex: -1,
        dataForm: {
          banco_id: '',
          numero: '',
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva tarjeta' : 'Editar tarjeta'
      },
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    created () {
      this.$store.dispatch('axiosMod/getData', { url: '/api/banco_get' }).then(r => { this.bancos = r })
      this.getTarjetas()
    },
    methods: {
      showItem (item) {
        this.showdialog = 'show'
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },
      getTarjetas: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tarjeta_get' }).then(response => { this.tarjetas = response })
      },
      editItem (item) {
        this.showdialog = 'edit'
        this.editedIndex = this.tarjetas.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/tarjeta_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Baja de tarjeta exitosa'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getTarjetas()
      },
      validateForm (scope) {
        if (this.mode === 'edit') {
          this.enviarTarjeta()
        }
      },
      enviarTarjeta: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/tarjeta_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.getTarjetas()
          this.close()
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de tarjeta exitosa'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
